export function mergeRefs(...refs) {
    return (e) => {
        for (const ref of refs) {
            if (!ref)
                continue;
            else if (typeof ref == 'function')
                ref(e);
            else
                ref.current = e;
        }
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVyZ2VSZWZzLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbIm1lcmdlUmVmcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLFVBQVUsU0FBUyxDQUN4QixHQUFHLElBQTBEO0lBRTdELE9BQU8sQ0FBQyxDQUFXLEVBQUUsRUFBRTtRQUN0QixLQUFLLE1BQU0sR0FBRyxJQUFJLElBQUksRUFBRSxDQUFDO1lBQ3hCLElBQUksQ0FBQyxHQUFHO2dCQUFFLFNBQVE7aUJBQ2IsSUFBSSxPQUFPLEdBQUcsSUFBSSxVQUFVO2dCQUFFLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQTs7Z0JBQ25DLEdBQWtDLENBQUMsT0FBTyxHQUFHLENBQUMsQ0FBQTtRQUNyRCxDQUFDO0lBQ0YsQ0FBQyxDQUFBO0FBQ0YsQ0FBQyJ9